import { ProcessedAudioArticlesRecommendationsItem } from "../audioArticlesRecommendationsUtils";
import { AudioArticlesRecommendationsAction, AudioArticlesRecommendationsItemCard } from "./audioArticlesRecommendationsItemCard";
import { AudioArticlesRecommendationsPlayer } from "./audioArticlesRecommendationsPlayer";
import { WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT } from "../../../article/componentas/articleHeaderComponenta/actionBarShared";

interface  AudioArticlesRecommendationsComponentaProps{
    listData?: ProcessedAudioArticlesRecommendationsItem[];
    isMobileWeb?: boolean;
    hideDate?: boolean;
    imagesDomain: string;
    domain: string;
};

interface AudioArticlesRecommendationsComponentaState {
    isOpen: boolean;
    selectedItem: ProcessedAudioArticlesRecommendationsItem | null;
    canScrollLeft: boolean;
    canScrollRight: boolean;
}

export class AudioArticlesRecommendationsComponenta extends React.Component<AudioArticlesRecommendationsComponentaProps, AudioArticlesRecommendationsComponentaState> {

    public static siteScriptName = "AudioArticlesRecommendationsComponenta";

    private itemsContainerRef: HTMLDivElement;

    constructor(props: AudioArticlesRecommendationsComponentaProps) {
        super(props);
        this.state = {
            isOpen: false,
            selectedItem: null,
            canScrollLeft: false,
            canScrollRight: false,
        };
    }

    componentDidMount() {
        if (typeof document === "undefined") {
            return;
        }
        document.addEventListener(WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT, this.handleRecommendationsOpen);
        if (typeof window !== "undefined") {
            window.addEventListener("resize", this.updateScrollArrows);
        }
    }

    componentDidUpdate(_prevProps: AudioArticlesRecommendationsComponentaProps, prevState: AudioArticlesRecommendationsComponentaState) {
        if (!prevState.isOpen && this.state.isOpen) {
            this.updateScrollArrows();
        }
    }

    componentWillUnmount() {
        if (typeof document === "undefined") {
            return;
        }
        document.removeEventListener(WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT, this.handleRecommendationsOpen);
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.updateScrollArrows);
        }
        this.detachItemsContainerListeners();
    }

    private detachItemsContainerListeners = () => {
        if (!this.itemsContainerRef) {
            return;
        }
        this.itemsContainerRef.removeEventListener("scroll", this.updateScrollArrows);
    }

    private setItemsContainerRef = (ref: HTMLDivElement) => {
        if (this.itemsContainerRef === ref) {
            return;
        }
        this.detachItemsContainerListeners();
        this.itemsContainerRef = ref;
        if (ref) {
            ref.addEventListener("scroll", this.updateScrollArrows, { passive: true } as AddEventListenerOptions);
            this.updateScrollArrows();
        }
    }

    private updateScrollArrows = () => {
        const el = this.itemsContainerRef;
        if (!el) {
            return;
        }

        const maxScroll = el.scrollWidth - el.clientWidth;
        if (maxScroll <= 1) {
            if (this.state.canScrollLeft || this.state.canScrollRight) {
                this.setState({ canScrollLeft: false, canScrollRight: false });
            }
            return;
        }

        const scrollLeft = el.scrollLeft;
        let canScrollLeft: boolean;
        let canScrollRight: boolean;

        if (scrollLeft < 0) {
            canScrollLeft = scrollLeft > -maxScroll + 1;
            canScrollRight = scrollLeft < -1;
        } else {
            const isRtl = typeof getComputedStyle !== "undefined" && getComputedStyle(el).direction === "rtl";
            if (isRtl) {
                canScrollLeft = scrollLeft < maxScroll - 1;
                canScrollRight = scrollLeft > 1;
            } else {
                canScrollLeft = scrollLeft > 1;
                canScrollRight = scrollLeft < maxScroll - 1;
            }
        }

        if (canScrollLeft !== this.state.canScrollLeft || canScrollRight !== this.state.canScrollRight) {
            this.setState({ canScrollLeft, canScrollRight });
        }
    }

    private hasRecommendationsData = () => {
        const { listData } = this.props;
        return !!(listData && listData.length > 0);
    }

    private handleRecommendationsOpen = () => {
        if (!this.hasRecommendationsData()) {
            return;
        }
        this.setState({ isOpen: true });
    }

    private onClose = () => {
        this.setState({ isOpen: false, selectedItem: null, canScrollLeft: false, canScrollRight: false });
    }

    private openPlayer = (item: ProcessedAudioArticlesRecommendationsItem) => {
        this.setState({ selectedItem: item });
    }

    private closePlayer = () => {
        this.setState({ selectedItem: null });
    }

    private scrollItems = (direction: "left" | "right") => {
        const container = this.itemsContainerRef;
        if (!container) {
            return;
        }

        const scrollDistance = Math.max(280, Math.floor(container.clientWidth * 0.7));
        const delta = direction === "left" ? -scrollDistance : scrollDistance;

        container.scrollBy({
            left: delta,
            behavior: "smooth",
        });
    }

    render() {
        const { listData, imagesDomain, isMobileWeb, hideDate } = this.props;
        const { canScrollLeft, canScrollRight } = this.state;

        if (!listData || listData.length === 0) {
            return null;
        }

        if (!this.state.isOpen) {
            return null;
        }

        const actions: AudioArticlesRecommendationsAction[] = ["youtube", "apple", "spotify"];

        const items = (
            <div className="itemsContainer" ref={isMobileWeb ? undefined : this.setItemsContainerRef}>
                {_.map(listData, (item: ProcessedAudioArticlesRecommendationsItem) => (
                    <AudioArticlesRecommendationsItemCard
                        key={item.id}
                        item={item}
                        hideDate={hideDate}
                        imagesDomain={imagesDomain}
                        categoryIconFirst={!!isMobileWeb}
                        actions={actions}
                        onCardClick={this.openPlayer}
                    />
                ))}
            </div>
        );

        const header = (
            <div className="recommendationsHeader">
                <div className="headerTitleRow">
                    <div className="headerLogoWrap">
                        <span className="headerLogo" aria-hidden="true" />
                    </div>
                    <h3 className="headerTitle">אולי יעניין אתכם: חדש ב-</h3>
                </div>
            </div>
        );

        return (
            <>
                <div className="AudioArticlesRecommendationsComponenta">
                    <div className="recommendationsContainer">
                        <button className="closeButton" aria-label="close" onClick={this.onClose} />
                        {isMobileWeb ? (
                            <div className="recommendationsContent">
                                {header}
                                {items}
                            </div>
                        ) : (
                            <>
                                {header}
                                <button
                                    className={`itemsArrow itemsArrowLeft${canScrollLeft ? " is-scrollable" : ""}`}
                                    aria-label="scroll left"
                                    aria-hidden={!canScrollLeft}
                                    tabIndex={canScrollLeft ? 0 : -1}
                                    onClick={() => this.scrollItems("left")}
                                />
                                {items}
                                <button
                                    className={`itemsArrow itemsArrowRight${canScrollRight ? " is-scrollable" : ""}`}
                                    aria-label="scroll right"
                                    aria-hidden={!canScrollRight}
                                    tabIndex={canScrollRight ? 0 : -1}
                                    onClick={() => this.scrollItems("right")}
                                />
                            </>
                        )}
                    </div>
                </div>
                {this.state.selectedItem && (
                    <AudioArticlesRecommendationsPlayer
                        item={this.state.selectedItem}
                        domain={this.props.domain}
                        isMobileWeb={!!isMobileWeb}
                        onClose={this.closePlayer}
                    />
                )}
            </>
        );
    }
}
